import { FulfillmentOrderAddressSchema } from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import { RateSchema } from "@redotech/redo-model/outbound-labels/outbound-labels";
import { OutboundParcelSchema } from "@redotech/redo-model/outbound-labels/parcel";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOmsReturnLabelRates = {
  name: "getOmsReturnLabelRates" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    shopperAddress: FulfillmentOrderAddressSchema,
    merchantAddress: FulfillmentOrderAddressSchema,
    parcel: OutboundParcelSchema,
  }),
  output: z.object({
    rates: z.array(RateSchema),
    errorMessage: z.string().optional(),
  }),
};
